


import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    scrollBehavior () {
        return { x: 0, y: 0 }
    },
    routes: [

      {
    // =============================================================================
    // MAIN LAYOUT ROUTES
    // =============================================================================
        path: '',
        component: () => import('./layouts/main/Main.vue'),
        children: [
      // =============================================================================
      // Theme Routes
      // =============================================================================
          {
            path: '/masiya-dashboard',
            name: 'masiya-dashboard',
            component: () => import('./views/Home.vue'),
          },
          {
            path: '/zain-dashboard',
            name: 'zain-dashboard',
            component: () => import('./views/zain/Dashboard.vue'),
          },
          {
            path: '/developer-dashboard',
            name: 'developer-dashboard',
            component: () => import('./views/developer/Dashboard.vue'),
          },
          {
            path: '/profile',
            name: 'profile',
            component: () => import('./views/pages/Profile.vue')
          },
          {
            path: '/interfaces/show',
            name: 'interfaces-show',
            component: () => import('./views/developer/Interfaces-Show.vue')
          },
          {
            path: '/interfaces/new',
            name: 'interfaces-add',
            component: () => import('./views/developer/Interfaces-Add.vue')
          },
          {
            path: '/interfaces/edit',
            name: 'interfaces-edit',
            component: () => import('./views/developer/Interfaces-Edit.vue'),
          },

          {
            path: '/users/show',
            name: 'users-show',
            component: () => import('./views/zain/Users-Show.vue')
          },
          {
            path: '/users/new',
            name: 'users-add',
            component: () => import('./views/zain/Users-Add.vue')
          },
          {
            path: '/users/edit',
            name: 'users-edit',
            component: () => import('./views/zain/Users-Edit.vue'),
          },
          {
            path: '/zain-interfaces',
            name: 'zain-interfaces',
            component: () => import('./views/zain/Interfaces-Show.vue')
          },
          {
            path: '/sandbox',
            name: 'sandbox',
            component: () => import('./views/thirdparty/Sandbox.vue')
          },
        ],
      },
    // =============================================================================
    // FULL PAGE LAYOUTS
    // =============================================================================
      {
        path: '',
        component: () => import('./layouts/full-page/FullPage.vue'),
        children: [
      // =============================================================================
      // PAGES
      // =============================================================================
          {
            path: '/pages/login',
            name: 'login',
            component: () => import('./views/pages/Login.vue')
          },
          {
            path: '/pages/error-404',
            name: 'pageError404',
            component: () => import('./views/pages/Error404.vue')
          },
        ]
      },
      // Redirect to 404 page, if no match found
      {
        path: '*',
        redirect: '/pages/error-404'
      }
    ],
});

router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
    if (appLoading) {
        appLoading.style.display = "none";
    }
});

export default router
